


























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import { CreateOrganizationResult,UpdateOrganizationBillingPlanDto } from '@/@types/Organization';
import { vxm } from '@/store';

@Component({
  components: {
    CommonModalHeader,
    CommonButton,
  },
})
export default class AddDirectoryModal extends Vue {
  @Prop(Boolean) public isOpenChangePlanModal!: boolean;
  @Prop(String) public plan!: string;
  private modalHeaderTitle: string = 'プランを変更します';
  private modalMode: string = 'move';
  private modalHeaderWidth: string = '550px';
  private selectedOrganization: CreateOrganizationResult = {
    organizationId: 0,
    organizationName: "",
    organizationIcon: "",
    organizationComment: "",
    sectorCd: "",
    billingPlan: "",
    organizationEmail: "",
    organizationPhoneNumber: "",
    organizationPerson: "",
    prefectureCd: "",
    cityCd: "",
    organizationStreetAddress: "",
    deleteFlag: false,
  };

  private created() {
    this.selectedOrganization = vxm.theoryApi.organizationsStore.getOrganization!;
  }

  @Emit('closeChangePlanModal')
  private closeChangePlanModal(): boolean {
    return false;
  }

  private changePlan() {
    const billingPlanDto: UpdateOrganizationBillingPlanDto = {
      billingPlan: this.plan
    };
    vxm.theoryApi.organizationsStore.updateOrganizationBillingPlan({organizationId:this.selectedOrganization.organizationId,updateOrganizationBillingPlanDto:billingPlanDto}).then(() => {
      this.selectedOrganization = vxm.theoryApi.organizationsStore.getOrganization!;
      this.closeChangePlanModal();
    });
  }
}
